export enum ReferralState {
  created = 'created',
  processing = 'processing',
  scheduled = 'scheduled',
  manualMatchRequired = 'manual_match_required',
  clientCanceled = 'client_canceled',
  matchingCanceled = 'matching_canceled',
  requiresRematch = 'requires_rematch',
  paused = 'paused'
}

export enum ClientUnpauseReasonState {
  INDEPENDENT_ACCOUNT_COMPLETION = 'independent_account_completion',
  PROPOSE_A_TIME = 'propose_a_time',
  REQUEST_TO_SCHEDULE = 'request_to_schedule',
  NON_CLINICAL_CHAT = 'non_clinical_chat'
}
